import { useState } from 'react';
import { useCanvasStore } from '@/pages/canvas/canvas-store';
import type { CanvasChatMessage } from '@/pages/canvas/canvas-types';
import { ChatToolProgressCard } from './ChatToolProgressCard';
import { PlaybookTaskCard } from './PlaybookTaskCard';
import { canvasWorkingLabels, summarizeCanvasProgress } from '@/pages/canvas/canvas-progress-summary';

/** Tool and playbook events describe the same request. Upgrade its existing
 * card in place, keeping disclosure state local to this message/run. */
export function CanvasRunProgressCard({ message, isActive }: { message: CanvasChatMessage; isActive: boolean }) {
  const [expanded, setExpanded] = useState(false);
  const [steering, setSteering] = useState(false);
  const [direction, setDirection] = useState("");
  const sendAgentMessage = useCanvasStore(state => state.sendAgentMessage);
  const canSteer = isActive && message.conceptsRun?.status === "generating" && message.conceptsRun.steeringOpen && !!message.conceptsRun.sourceRunMessageId;
  const hasImageGallery = message.imageSlots?.some(slot => !!slot.resolved)
    || (!message.imageSlots?.length && !!message.thumbnails?.length);
  return <div data-testid={`canvas-run-progress-${message.id}`}>
    <div role="status" style={{ display: "flex", alignItems: "center", gap: 12, fontSize: 13, color: "#777b80", marginBottom: 8 }}>
      <span>{isActive ? canvasWorkingLabels(message)[0] : summarizeCanvasProgress(message, false)[0]}</span>
      <button type="button" aria-expanded={expanded} aria-controls={`run-process-${message.id}`} onClick={() => setExpanded(value => !value)} style={{ font: "inherit", background: "none", border: 0, color: "inherit", cursor: "pointer" }}>{expanded ? "Hide process" : "Show process"}</button>
    </div>
    {canSteer && <div style={{ marginBottom: 8 }}>
      {!steering ? <button type="button" style={{ fontSize: 12, color: "#777b80", textDecoration: "underline" }} onClick={() => setSteering(true)}>Steer remaining concepts</button> : <form style={{ display: "flex", flexWrap: "wrap", gap: 8, fontSize: 13 }} onSubmit={event => {
        event.preventDefault();
        if (!direction.trim() || !message.conceptsRun?.sourceRunMessageId) return;
        void sendAgentMessage(direction.trim(), undefined, {conceptSteering:{sourceRunMessageId:message.conceptsRun.sourceRunMessageId, revision:message.conceptsRun.revision ?? 0}});
        setSteering(false);
      }}>
        <label style={{ width: "100%" }}>Direction for concepts that have not started<input style={{ display: "block", width: "100%", padding: 8, border: "1px solid #ddd", borderRadius: 6, marginTop: 4 }} aria-label="Direction for remaining concepts" value={direction} onChange={event => setDirection(event.target.value)} maxLength={8000} /></label>
        <button type="submit" disabled={!direction.trim()}>Apply direction</button>
        <button type="button" onClick={() => setSteering(false)}>Cancel</button>
        <p style={{ fontSize: 12 }}>Completed concepts and concepts already being written are preserved.</p>
      </form>}
    </div>}
    {expanded && <div id={`run-process-${message.id}`}>{message.playbookProgress ? (
      <PlaybookTaskCard progress={message.playbookProgress} messageId={message.id}
        messageImageSlots={message.imageSlots} isActive={isActive}
        showThumbnails={!hasImageGallery}
        expanded={expanded} onExpandedChange={setExpanded} />
    ) : (
      <ChatToolProgressCard groups={message.agentTaskGroups ?? []} isStreaming={isActive}
        expanded={expanded} onExpandedChange={setExpanded} />
    )}</div>}
  </div>;
}
